export default __webpack_public_path__ + "static/media/area-83.dad085c4.jpg";